import styled from 'styled-components'

export const GenderContainer = styled.div`
  padding-bottom: 30px;
`

export const GenderRadioButtons = styled.div`
  display: flex;
  margin-top: 10px;
  gap: 40px;
`